import { motion } from "framer-motion";
import { Reveal, Overline } from "./Reveal";
import { SKILLS, TOOLS } from "../data/content";

export const Skills = () => (
  <section
    id="skills"
    className="relative mx-auto max-w-[1400px] px-6 py-28 lg:px-10 lg:py-40"
    data-testid="skills-section"
  >
    <div className="grid gap-16 lg:grid-cols-12">
      {/* Capabilities */}
      <div className="lg:col-span-7">
        <Reveal>
          <Overline>Capabilities</Overline>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-serif text-4xl tracking-tight text-white sm:text-5xl">
            Skills &amp; Craft
          </h2>
        </Reveal>
        <div className="mt-12 flex flex-col">
          {SKILLS.map((skill, i) => (
            <motion.div
              key={skill}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
              className="group flex items-baseline gap-5 border-b border-white/10 py-5"
              data-testid={`skill-${i}`}
            >
              <span className="text-xs text-gold/70">0{i + 1}</span>
              <span className="font-serif text-2xl text-zinc-300 transition-colors duration-300 group-hover:text-white sm:text-3xl">
                {skill}
              </span>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Tools */}
      <div className="lg:col-span-4 lg:col-start-9">
        <Reveal delay={0.15}>
          <p className="text-xs uppercase tracking-luxury text-zinc-500">Tools</p>
          <div className="mt-5 flex flex-wrap gap-2.5">
            {TOOLS.map((t) => (
              <span
                key={t}
                data-testid={`tool-${t.toLowerCase().replace(/\s+/g, "-")}`}
                className="rounded-full border border-white/10 bg-white/[0.03] px-4 py-2 text-sm text-zinc-300 transition-colors duration-300 hover:border-gold/40 hover:text-white"
              >
                {t}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
